module.exports = __webpack_public_path__ + "img/icon-calendar.274373be.svg";